import getBrowserLocale from 'scoreboard/components/locale'

/**
 * Represents all languages supported by Impact
 *
 * @enum {string}
 */
const Language = {
    ARABIC: 'arabic',
    ENGLISH: 'english',
    FRENCH: 'french',
    SPANISH: 'spanish',
    PORTUGUESE: 'portuguese',
    TURKISH: 'turkish'
}

// Export individual constants for direct usage
export const ARABIC = Language.ARABIC
export const ENGLISH = Language.ENGLISH
export const FRENCH = Language.FRENCH
export const SPANISH = Language.SPANISH
export const PORTUGUESE = Language.PORTUGUESE
export const TURKISH = Language.TURKISH

/**
 * Maps ISO language codes to their corresponding Language enum value
 * @type {Object.<string, Language>}
 */
const languageCodeMap = {
    'ar': Language.ARABIC,
    'en': Language.ENGLISH,
    'fr': Language.FRENCH,
    'es': Language.SPANISH,
    'pt': Language.PORTUGUESE,
    'tr': Language.TURKISH
}

/**
 * Gets the language enum value based on the browser's locale
 * @returns {string} The language enum value, defaults to ENGLISH if not found
 */
export function getBrowserLanguage () {
    const locale = getBrowserLocale()
    return languageCodeMap[locale.language] ?? Language.ENGLISH
}

/**
 * Gets an array of all supported language values
 * @returns {Language[]} Array of language values
 */
export function getAllLanguages() {
    return Object.values(Language)
}
